import { cn } from '~/utils/cn'
import { type VariantProps, tv } from '~/utils/tv'

const inputPasswordTag = tv({
  base: [
    'inline-flex h-[var(--sizing-extrasmall)] select-none items-center rounded-[var(--border-radius-pill)] px-[var(--padding-inset-twopulse)]',
    'font-semibold text-[length:var(--font-size-threepulse)]',
  ],
  variants: {
    variant: {
      strong: [
        '[--color-labeling-fill-strong-default:#ABF7CD] [--color-labeling-text-strong-default:#18492E]',
        'bg-[var(--color-labeling-fill-strong-default)] text-[var(--color-labeling-text-strong-default)]',
      ],
      average: [
        '[--color-labeling-fill-average-default:#FBEBD0] [--color-labeling-text-average-default:#55350C]',
        'bg-[var(--color-labeling-fill-average-default)] text-[var(--color-labeling-text-average-default)]',
      ],
      weak: [
        '[--color-labeling-fill-weak-default:#FCCFEA] [--color-labeling-text-weak-default:#642049]',
        'bg-[var(--color-labeling-fill-weak-default)] text-[var(--color-labeling-text-weak-default)]',
      ],
    },
  },
})

export type InputPasswordTagProps = VariantProps<typeof inputPasswordTag>

export function InputPasswordTag({ variant = 'weak' }: InputPasswordTagProps) {
  const passwordStrengthLabels = {
    strong: 'Forte',
    average: 'Média',
    weak: 'Fraca',
  } as Record<typeof variant, string>

  return (
    <span
      className={cn(
        inputPasswordTag({
          variant,
        })
      )}
    >
      {passwordStrengthLabels[variant]}
    </span>
  )
}
